'use strict';

const formatStatNumber = (value) => {
  if (typeof value !== 'number' || !isFinite(value)) return '-';
  if (value >= 10000) {
    const thousands = value / 1000;
    return (thousands >= 100 ? Math.round(thousands) : thousands.toFixed(1).replace(/\.0$/, '')) + 'K';
  }
  return value.toLocaleString('en-US');
};

const setupFaqToggle = () => {
  // Exposed globally because the FAQ markup uses onclick="toggleFaq(this)".
  window.toggleFaq = (button) => {
    const answer = button.nextElementSibling;
    const isOpen = answer.classList.contains('open');
    document.querySelectorAll('.faq-q').forEach((question) => question.classList.remove('open'));
    document.querySelectorAll('.faq-a').forEach((answerEl) => answerEl.classList.remove('open'));
    if (!isOpen) {
      button.classList.add('open');
      answer.classList.add('open');
    }
  };
};

const cloneMeetArtistsCtaForMobile = () => {
  const heroBody = document.querySelector('body.template-page-new-artists [class*="hero-body-"]');
  if (!heroBody) return;

  const originalLink = heroBody.querySelector('[class*="hero-text-"] a');
  if (!originalLink || originalLink.dataset.ctaMoved === '1') return;

  originalLink.classList.add('btn');
  originalLink.setAttribute('data-cta', 'meet-artists');
  originalLink.dataset.ctaMoved = '1';

  const mobileCta = document.createElement('div');
  mobileCta.className = 'ss-hero-12-mobile-cta';
  mobileCta.appendChild(originalLink.cloneNode(true));

  const slider = heroBody.querySelector('[class*="hero-slide-wrapper-"]');
  if (slider) {
    slider.insertAdjacentElement('afterend', mobileCta);
  } else {
    heroBody.appendChild(mobileCta);
  }
};

const trackCtaClicksWithMetaPixel = () => {
  if (window.__klydoNewArtistsCtaBound) return;
  window.__klydoNewArtistsCtaBound = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cta]');
    if (!button) return;
    if (typeof window.fbq !== 'function') return;
    window.fbq('trackCustom', 'CtaClick', {
      cta_location: button.dataset.cta,
      page: 'new-artists',
    });
  });
};

const fetchArtistJson = (url) =>
  fetch(url, { headers: { Accept: 'application/json' } }).then((response) => {
    if (!response.ok) throw new Error(`${url} -> ${response.status}`);
    return response.json();
  });

const renderArtistStat = (card, statName, value) => {
  const cell = card.querySelector(`[data-stat="${statName}"] .stats-number`);
  if (cell) cell.textContent = value;
};

const loadStatsForArtistCard = async (card) => {
  const artistId = card.dataset.artistId;
  if (!artistId || card.dataset.statsLoaded === '1') return;
  card.dataset.statsLoaded = '1';

  const encodedId = encodeURIComponent(artistId);
  try {
    const [downloadStats, klydosResponse] = await Promise.all([
      fetchArtistJson(`${API_BASE_URL}/public/artist/${encodedId}/collections/download-stats`),
      fetchArtistJson(`${API_BASE_URL}/public/artist/${encodedId}/klydos?page=0&pageSize=1000`),
    ]);

    const totalDownloads = Array.isArray(downloadStats)
      ? downloadStats.reduce((sum, item) => sum + (item.downloadCount || 0), 0)
      : 0;
    const totalKlydos = klydosResponse?.total ?? 0;
    const totalFavorites = Array.isArray(klydosResponse?.items)
      ? klydosResponse.items.reduce((sum, klydo) => sum + (klydo.stats?.favorites ?? 0), 0)
      : 0;

    renderArtistStat(card, 'downloads', formatStatNumber(totalDownloads));
    renderArtistStat(card, 'klydos', formatStatNumber(totalKlydos));
    renderArtistStat(card, 'favorites', formatStatNumber(totalFavorites));
  } catch (error) {
    console.warn('[new-artists] Failed to load stats for artist', artistId, error);
  }
};

const loadAllArtistStats = () => {
  document.querySelectorAll('.stats-card[data-artist-id]').forEach(loadStatsForArtistCard);
};

const initNewArtistsPage = () => {
  setupFaqToggle();
  cloneMeetArtistsCtaForMobile();
  trackCtaClicksWithMetaPixel();
  loadAllArtistStats();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNewArtistsPage);
} else {
  initNewArtistsPage();
}
